import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import BootstrapVue3 from "bootstrap-vue-3";
import { createMetaManager } from "vue-meta";
import VueProgressBar from "@aacassandra/vue3-progressbar";
import i18n from "./i18n";
import yaml from "js-yaml";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "./styles/mainStyle.scss";
import "animate.css";

async function preloadLanguages(langs = ["fr", "de"]) {
  for (const lang of langs) {
    const res = await fetch(`/lang/${lang}.yml?version=1`);
    const blob = await res.blob();
    const yamlAsString = await blob.text();
    const dataJson = yaml.load(yamlAsString, "utf8");
    i18n.global.setLocaleMessage(lang, dataJson);
  }

  const savedLang = localStorage.getItem("lang") || i18n.global.locale.value;
  i18n.global.locale.value = savedLang;
}

preloadLanguages().then(() => {
  const app = createApp(App);

  axios.defaults.baseURL = "https://www.googleapis.com/youtube/v3/";
  app.config.globalProperties.$http = axios;

  router.beforeEach((to, from, next) => {
    const title = i18n.global.t("accueil.meta.title");
    const description = i18n.global.t("accueil.video_principal.description");

    document.title = title;

    let descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute("content", description);
    } else {
      descriptionTag = document.createElement("meta");
      descriptionTag.name = "description";
      descriptionTag.content = description;
      document.head.appendChild(descriptionTag);
    }

    next();
  });

  app.use(router);
  app.use(store);
  app.use(i18n);
  app.use(BootstrapVue3);
  app.use(createMetaManager());
  app.use(VueProgressBar, {
    color: "#30591a",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
      speed: "0.2s",
      opacity: "0.6s",
      termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
  });

  app.mount("#app");
});
